import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../services/supabaseClient'
import { useAuth } from '../context/AuthContext'

function statusLabel(status) {
  switch (status) {
    case 'present':
      return 'حاضر'
    case 'absent':
      return 'غائب'
    case 'late':
      return 'متأخر'
    case 'excused':
      return 'مُعذَر'
    default:
      return status || ''
  }
}

function statusStyle(status) {
  if (status === 'present') {
    return { background: '#dcfce7', color: '#15803d', border: '1px solid #bbf7d0' }
  }
  if (status === 'absent') {
    return { background: '#fee2e2', color: '#b91c1c', border: '1px solid #fecaca' }
  }
  if (status === 'late') {
    return { background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a' }
  }
  if (status === 'excused') {
    return { background: '#e0f2fe', color: '#1d4ed8', border: '1px solid #bfdbfe' }
  }
  return { background: '#e5e7eb', color: '#374151', border: '1px solid #d1d5db' }
}

export default function Attendance() {
  const { user, signOut } = useAuth()
  const email = user?.email || ''
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [rows, setRows] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    let active = true
    ;(async () => {
      setLoading(true)
      setError('')

      const today = new Date()
      const from = new Date(today)
      from.setDate(today.getDate() - 30)
      const to = new Date(today)

      const fromStr = from.toISOString().slice(0, 10)
      const toStr = to.toISOString().slice(0, 10)

      const { data, error: rpcError } = await supabase.rpc('get_kg_kid_attendance', {
        p_from: fromStr,
        p_to: toStr,
      })
      if (!active) return
      if (rpcError) {
        setError(rpcError.message || 'حدث خطأ أثناء تحميل سجل الحضور')
        setRows([])
      } else {
        setRows(data || [])
      }
      setLoading(false)
    })()
    return () => { active = false }
  }, [])

  const today = new Date()
  const from = new Date(today)
  from.setDate(today.getDate() - 30)
  const to = new Date(today)

  const rangeLabel = `${from.toLocaleDateString('ar-EG', { day: 'numeric', month: 'long' })} 
إلى ${to.toLocaleDateString('ar-EG', { day: 'numeric', month: 'long' })}`

  const summary = rows.reduce((acc, r) => {
    const s = r.status || 'present'
    acc[s] = (acc[s] || 0) + 1
    return acc
  }, {})

  return (
    <div
      dir="rtl"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        padding: '1.5rem',
      }}
    >
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: 16,
            padding: 16,
            boxShadow: '0 10px 25px rgba(15,23,42,0.08)',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h1 style={{ margin: 0 }}>الحضور - رياض الأطفال</h1>
            <button
              type="button"
              onClick={signOut}
              style={{
                padding: '6px 10px',
                borderRadius: 999,
                border: '1px solid #e5e7eb',
                background: '#f9fafb',
                cursor: 'pointer',
                fontSize: 13,
              }}
            >
              تسجيل الخروج
            </button>
          </div>

          <div style={{ color: '#6b7280', marginTop: 4, marginBottom: 12, fontSize: 14 }}>
            عرض سجل حضور الطفل في مرحلة رياض الأطفال خلال آخر 30 يومًا.
          </div>

          <div style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={() => navigate('/')}
                style={{ padding: '6px 10px', borderRadius: 999, border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontSize: 13 }}
              >
                لوحة المعلومات
              </button>
              <button
                type="button"
                disabled
                style={{ padding: '6px 10px', borderRadius: 999, border: '1px solid #2563eb', background: '#2563eb', color: '#fff', cursor: 'default', fontSize: 13 }}
              >
                الحضور
              </button>
              <button
                type="button"
                onClick={() => navigate('/daily-plan')}
                style={{ padding: '6px 10px', borderRadius: 999, border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontSize: 13 }}
              >
                خطة اليوم
              </button>
              <button
                type="button"
                onClick={() => navigate('/assessment')}
                style={{ padding: '6px 10px', borderRadius: 999, border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontSize: 13 }}
              >
                التقييم
              </button>
              <button
                type="button"
                onClick={() => navigate('/fees')}
                style={{ padding: '6px 10px', borderRadius: 999, border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontSize: 13 }}
              >
                الرسوم
              </button>
            </div>
          </div>

          {email && (
            <p style={{ marginBottom: 8 }}>تم تسجيل الدخول بالبريد: <strong>{email}</strong></p>
          )}

          {rows.length > 0 && (
            <div
              style={{
                marginTop: 8,
                marginBottom: 12,
                padding: 12,
                borderRadius: 12,
                background: '#f9fafb',
                border: '1px solid #e5e7eb',
                fontSize: 13,
              }}
            >
              <span style={{ marginInlineEnd: 12 }}>الفترة: <strong>{rangeLabel}</strong></span>
              <span style={{ marginInlineEnd: 12 }}>إجمالي الأيام المسجلة: <strong>{rows.length}</strong></span>
              {'present' in summary && (
                <span style={{ marginInlineEnd: 8 }}>حضور: <strong>{summary.present}</strong></span>
              )}
              {'absent' in summary && (
                <span style={{ marginInlineEnd: 8 }}>غياب: <strong>{summary.absent}</strong></span>
              )}
              {'late' in summary && (
                <span style={{ marginInlineEnd: 8 }}>تأخر: <strong>{summary.late}</strong></span>
              )}
              {'excused' in summary && (
                <span>مُعذَر: <strong>{summary.excused}</strong></span>
              )}
            </div>
          )}

          {loading && (
            <div style={{ textAlign: 'center', marginTop: 24 }}>جاري تحميل سجل الحضور...</div>
          )}

          {!loading && error && (
            <div style={{ color: '#b91c1c', marginTop: 16 }}>{error}</div>
          )}

          {!loading && !error && rows.length === 0 && (
            <div style={{ marginTop: 16 }}>لا يوجد سجل حضور في الفترة المحددة.</div>
          )}

          {!loading && !error && rows.length > 0 && (
            <ul style={{ listStyle: 'none', padding: 0, marginTop: 16 }}>
              {rows.map((r, idx) => (
                <li
                  key={`${r.session_date}-${idx}`}
                  style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: 8,
                    padding: 12,
                    marginBottom: 8,
                    background: '#fff',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                    <div>
                      التاريخ: <strong>{String(r.session_date)}</strong>
                    </div>
                    <div
                      style={{
                        padding: '2px 8px',
                        borderRadius: 999,
                        fontSize: 11,
                        ...statusStyle(r.status),
                      }}
                    >
                      {statusLabel(r.status)}
                    </div>
                  </div>
                  {r.minutes_late != null && r.minutes_late > 0 && (
                    <div style={{ marginBottom: 2 }}>
                      دقائق التأخر: <strong>{r.minutes_late}</strong>
                    </div>
                  )}
                  {r.reason && (
                    <div style={{ marginTop: 2, fontSize: 14, color: '#4b5563' }}>
                      الملاحظة: {r.reason}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}
